import { Component, Input, OnInit, OnDestroy, Optional } from '@angular/core';
import { FormGroup, ControlContainer, FormControl, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrls: ['./validation-errors.scss']
})
export class ValidationErrorsComponent implements OnInit, OnDestroy {

  private _formControl: AbstractControl;
  private _errors: [];
  private _statusChangesSubscription?: Subscription;

  @Input() public for: string;
  @Input() public aliasTo: string;
  @Input() public formGroup: FormGroup;
  @Input() public errorsFormGroup: FormGroup;
  @Input() public showErrorText = true;

  @Input() public set errors(val) {
    this._errors = val;
  }

  public get hasMultipleErrors() {
    return this.errors?.length > 1;
  }

  public get hasAnyErrors() {
    return this.errors?.length > 0;
  }

  public get showContent() {
    return this.showErrorText && this.hasAnyErrors;
  }

  public get errors() {

    if (this._formControl) {
      return this._formControl.errors;
    }

    const fg = this.errorsFormGroup || this.formGroup;
    return fg.errors ? fg.errors[this.for] : this._errors;
  }

  public constructor(
    @Optional()  private _controlContainer: ControlContainer) {
  }

  public ngOnInit() {

    if (!this.formGroup) {
      if (this._controlContainer && this._controlContainer.control instanceof FormGroup) {
        this.formGroup = <FormGroup>this._controlContainer.control;
      }
    }

    if (this.aliasTo) {
      this._formControl = this.formGroup.get(this.aliasTo);
      if (this._formControl) {

        const fg = this.errorsFormGroup || this.formGroup;

        this._statusChangesSubscription = fg.statusChanges.subscribe((x: any) => {
            const oldErrors = this._formControl.errors;
            const newErrors = fg.errors ? (fg.errors[this.for] || null) : null;
            if (oldErrors !== newErrors) {
              this._formControl.setErrors(newErrors);
          }
        });
      }
    } else if (this.for) {
      this._formControl = this.formGroup.get(this.for);
    }
  }

  public ngOnDestroy(): void {
    if (this._statusChangesSubscription) {
      this._statusChangesSubscription.unsubscribe();
    }
  }
}
